import { LinkIcon, ArrowLeftIcon } from "../../../assets/icons"
import cx from "classnames"
import { useState } from "react"

import type { SidebarProps, MenuItem } from "./types"

import styles from "./index.module.css"

export const Sidebar = ({
  menu,
  currentRoute,
  isCollapsable = false,
  isOpen = false,
  returnText = "Volver",
  onRouteChange,
}: SidebarProps) => {
  const [activeSectionIndex, setActiveSectionIndex] = useState<number | null>(null)

  const MenuItem = ({ icon: Icon, label, url, onClick, index, description, items = [] }: MenuItem) => {
    const showLabel = isOpen || !isCollapsable
    const isSectionHeader = items.length > 0
    const isCurrent = currentRoute === url

    const isExternal = url?.startsWith("http")

    const handleClick = () => {
      if (isSectionHeader) {
        setActiveSectionIndex(index!)
      } else {
        if (onClick) onClick()
        if (url) onRouteChange?.(url)
      }
    }

    return (
      <div className={cx(styles.label, { [styles.current]: isCurrent })} onClick={handleClick}>
        <span className={styles.title}>
          <span className={styles.icon}>
            <Icon />
          </span>
          {showLabel && <span className={styles.labelText}>{label}</span>}

          {isExternal && showLabel && (
            <span className={styles.labelIconSubExternal}>
              <LinkIcon />
            </span>
          )}
        </span>

        {description && <div className={styles.description}>{description}</div>}
      </div>
    )
  }

  return (
    <div className={styles.container}>
      <div className={styles.background}>
        {activeSectionIndex === null ? (
          <>
            {menu.map((item, index) => {
              return <MenuItem key={index} index={index} {...item} />
            })}
          </>
        ) : (
          <>
            <div className={styles.backButton} onClick={() => setActiveSectionIndex(null)}>
              <ArrowLeftIcon />
              {returnText}
            </div>
            {menu[activeSectionIndex].items?.map((subitem, i) => (
              <MenuItem key={i} {...subitem} />
            ))}
          </>
        )}
      </div>
    </div>
  )
}

export type { SidebarProps, MenuItem, SubMenuItem } from "./types"
